// What TUNE Analytics needs to know about its stage: Cognito's API and each pool's client. It's /config.json,
// written for each stage as it's deployed, and on this machine by the local cloud (shared/src/portal.ts).
import type { PortalConfig } from '@tune/shared';

export type { PortalConfig } from '@tune/shared';

export type Pool = 'owners' | 'staff';

export async function loadConfig(): Promise<PortalConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`the portal's config answered ${res.status}`);
  }
  return (await res.json()) as PortalConfig;
}
